module.exports = __webpack_public_path__ + "static/media/1013532.5a179b67.png";